import request from '@/utils/request'
const api_name = 'propertymanagementfee'
export default{
    getAllpropertymanagementfee(){
        return request({
            url:`/${api_name}/getallpropertymanagementfees`,
            method:'get'
        })
    },
    getpropertymanagementfeeBypropertymanagementfee(pojo){
        return request({
            url:`/${api_name}/getpropertymanagementfeebypropertymanagementfeesubject`,
            method:'post',
            data:pojo
        })
    },
    addpropertymanagementfee(pojo){
        return request({
            url:`/${api_name}/addpropertymanagementfee`,
            method:'post',
            data:pojo
        })
    },
    updatepropertymanagementfee(pojo){
        return request({
            url:`/${api_name}/updatepropertymanagementfee`,
            method:'post',
            data:pojo
        })
    },
    deletepropertymanagementfee(id){
        return request({
            url:`/${api_name}/deletepropertymanagementfee?id=`+id,
            method:'delete',
        })
    },
    
}







